<template>
  <div>
    <UserV2 v-if="$store.state.experiments['USER_V2']" />
    <User v-else />
  </div>
</template>

<script>
import User from "@/views/User.vue"
import UserV2 from "@/views/UserV2/User.vue"

export default {
  name: "UserWrapper",
  components: {
    User,
    UserV2
  }
}
</script>

<style scoped></style>
